import { render, staticRenderFns } from "./PlusEditor.vue?vue&type=template&id=456d4797&scoped=true"
import script from "./PlusEditor.vue?vue&type=script&lang=js"
export * from "./PlusEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456d4797",
  null
  
)

export default component.exports